import products from './products';
import tenants from './tenants';
import permits from './permits';
import validatePermit from './validatePermit';
import parkings from './parkings';
import landlords from './landlords';
import zones from './zones';
import users from './users';
import blacklists from './blacklists';
import maps from './maps';
import lastEditeds from './lastEditeds';
import lastEditedsGuest from './lastEditedsGuest';

export default {
  namespaced: true,
  modules: {
    products,
    tenants,
    permits,
    validatePermit,
    parkings,
    landlords,
    zones,
    users,
    blacklists,
    maps,
    lastEditeds,
    lastEditedsGuest,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/index.js